import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchSimoDeviceDiagnostic } from '../../../actions/simoDiagnostic';
import { getSimoDeviceDiagnostics } from '../../../reducers';
import Spinner from 'components/Spinner';
import DiagnosticData from 'components/simo/DiagnosticData';
import {
  restartSimoConnection,
  restartSimoDevice,
  sendSimoSignalScan,
} from 'api';

class DiagnosticInfo extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.fetchDiagnoticData();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.simoDeviceId !== this.props.simoDeviceId) {
      this.fetchDiagnoticData();
    }
  }

  fetchDiagnoticData = () => {
    const { fetchSimoDeviceDiagnostic, simoDeviceId } = this.props;
    this.setState({ loading: true });
    fetchSimoDeviceDiagnostic(simoDeviceId)
      .then(() => this.setState({ loading: false }))
      .catch((e) => {
        this.setState({
          error: 'Failed to load diagnostic data',
          loading: false,
        });
      });
  };

  handleRestartConnection = async () => {
    const { simoDeviceId } = this.props;
    this.setState({ loading: true, actionsError: '' });
    try {
      await restartSimoConnection(simoDeviceId);
    } catch (e) {
      const error =
        (e.response && e.response.data && e.response.data.detail) || e.message;
      this.setState({ actionsError: error });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleRestartDevice = async () => {
    const { simoDeviceId } = this.props;
    this.setState({ loading: true, actionsError: '' });
    try {
      await restartSimoDevice(simoDeviceId);
    } catch (e) {
      const error =
        (e.response && e.response.data && e.response.data.detail) || e.message;
      this.setState({ actionsError: error });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSendSignalScan = async () => {
    const { simoDeviceId } = this.props;
    this.setState({ loading: true, actionsError: '' });
    try {
      await sendSimoSignalScan(simoDeviceId, {});
    } catch (e) {
      const error =
        (e.response && e.response.data && e.response.data.detail) || e.message;
      this.setState({ actionsError: error });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { diagnostic, simoDeviceId } = this.props;
    const { error, loading, actionsError } = this.state;

    if (error) {
      return (
        <div>
          <h1>Simo Device Diagnostic Information</h1>
          <br />
          {error}
        </div>
      );
    }

    return (
      <div className="relative">
        <br />
        <div className="d-flex-vc" style={{ margin: '20px 0 10px' }}>
          <h2 style={{ margin: '0' }}>Simo Device Diagnostic Information</h2>
          <img
            style={{
              width: '32px',
              height: '32px',
              marginLeft: '15px',
              cursor: 'pointer',
            }}
            onClick={this.fetchDiagnoticData}
            src="/images/refresh-icon.svg"
            alt="refresh"
          />
        </div>
        <br />
        <DiagnosticData
          simoDeviceId={simoDeviceId}
          diagnostic={diagnostic}
          restartConnection={this.handleRestartConnection}
          restartDevice={this.handleRestartDevice}
          sendSignalScan={this.handleSendSignalScan}
          actionsError={actionsError}
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { simoDeviceId }) => ({
  diagnostic: getSimoDeviceDiagnostics(state, simoDeviceId),
});

const mapDispatchToProps = {
  fetchSimoDeviceDiagnostic,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiagnosticInfo);
